module.exports = __webpack_public_path__ + "img/saddle-cloths-18.28f98881.svg";